<div class="matero-container-wrap matero-header-above matero-navbar-side" [ngClass]="{
    'matero-sidenav-collapsed': options.sidenavCollapsed,
    'matero-header-white': !sharedService.darkMode
  }" [dir]="options.dir">
  <a class="skip-link" href="#main-content" (click)="$event.preventDefault(); mainContent.focus()">Skip to main content</a>
  <ng-progress name="progress" aria-label="progress"></ng-progress>

  <!-- Header Above -->

  <app-navbar (toggleSidenav)="sidenav.toggle()"></app-navbar>

  <app-timeout *ngIf="useTimeout"></app-timeout>

  <mat-sidenav-container class="matero-container" autosize autoFocus>
    <mat-sidenav #sidenav class="matero-sidenav" [mode]="isMobile ? 'over' : 'side'" [opened]="sidenavOpen()"
      (openedChange)="sidenavOpenedChange($event)" (closedStart)="sidenavCloseStart()">
      <app-sidebar (toggleCollapsed)="toggleCollapsed()" (toggleSidenav)="sidenav.toggle()" [isMobile]="isMobile" [ripple]="!isMobile">
      </app-sidebar>
    </mat-sidenav>

    <mat-sidenav-content #content class="flex flex-col matero-content-wrap">
      <main #mainContent id="main-content" tabindex="-1" class="matero-content">
        <router-outlet *ngIf="!isIframe"></router-outlet>
      </main>
      <app-footer></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
